export default class OrderSourcesModel {
    id: number | null;
    name: string | null;
    uuid: string | null;
    projectUuid: string | null;
    integrationUuid: string | null;
    color: string | null;
    createdAt: string | null;
    updatedAt: string | null;

    constructor(
        id: number,
        name: string,
        uuid: string,
        projectUuid: string,
        integrationUuid: string,
        color: string,
        createdAt: string,
        updatedAt: string
    ) {
        this.id = id || null;
        this.name = name || null;
        this.uuid = uuid || null;
        this.projectUuid = projectUuid || null;
        this.integrationUuid = integrationUuid || null;
        this.color = color || null;
        this.createdAt = createdAt || null;
        this.updatedAt = updatedAt || null;
    }
}